import React, { useEffect, useState } from 'react';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { Card, CardContent, Grid, TextField, Button, Typography } from '@mui/material';
import imgurl from './assests/images/imgurl';
import Checkbox from '@mui/material/Checkbox';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FormControlLabel from '@mui/material/FormControlLabel';
import stg1_side_prev from "./assests/images/resultpgimgs/stage1_side.svg"
import stg1_top_prev from './assests/images/resultpgimgs/stage1_top.svg'
import stg2_side_prev from './assests/images/resultpgimgs/stage2_side.svg'
import stg2_top_prev from './assests/images/resultpgimgs/stage2_top.svg'
import stg3_side_prev from './assests/images/resultpgimgs/stage3_side.svg'
import stg3_top_prev from './assests/images/resultpgimgs/stage3_top.svg'
import stg4_side_prev from './assests/images/resultpgimgs/stage4_side.svg'
import stg4_top_prev from './assests/images/resultpgimgs/stage4_top.svg'
import stg5_side_prev from './assests/images/resultpgimgs/stage5_side.svg'
import stg5_top_prev from './assests/images/resultpgimgs/stage5_top.svg'
import stg6_side_prev from './assests/images/resultpgimgs/stage6_side.svg'
import stg6_top_prev from './assests/images/resultpgimgs/stage6_top.svg'
import stg7_side_prev from './assests/images/resultpgimgs/stage7_side.svg'
import stg7_top_prev from './assests/images/resultpgimgs/stage7_top.svg'
import { replace, useNavigate } from "react-router-dom";

function AssessmentReport() {
    const navigate = useNavigate();
    const [consentchk, setconsentchk] = useState(false)


    function toggleChckBox(e) {
        setconsentchk(e.target.checked)
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "phone_number": localStorage.getItem('phno'),
            "wtsappconsent": e.target.checked
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://aloxa.ai/flaskservice/update_whatsapp_consent", requestOptions)
            .then(response => response.text())
            .then(result => console.log(result))
            .catch(error => console.log('error', error));
    }

    const norwoodHamiltonStages = {
        "stage 2": {
            'description': "Stage 2 male pattern hair loss is marked by slight recession of the hairline around the temples, forming an adult or mature hairline. This stage is often not noticeable and is considered a normal part of aging.",
            'duration': '6 Months',
            'possibility': '75%',
            'img_side': stg2_side_prev,
            'img_top': stg2_top_prev,
        },
        "stage 3": {
            'description': "Stage 3 male pattern hair loss is marked by deep recession at the temples, forming an M, U, or V shape. The recessed areas are mostly bare, and this stage marks the beginning of clinically significant balding.",
            'duration': '6 Months',
            'possibility': '65%',
            'img_side': stg3_side_prev,
            'img_top': stg3_top_prev,
        },
        "stage 4": {
            'description': "Stage 4 male pattern hair loss is marked by severe hairline recession and significant hair loss on the top of the scalp (vertex). The two areas of hair loss are separated by a band of hair that connects to the hair remaining on the sides of the scalp.",
            'duration': '6 Months',
            'possibility': '45%',
            'img_side': stg4_side_prev,
            'img_top': stg4_top_prev,
        },
        "stage 5": {
            'description': "Stage 5 male pattern hair loss is marked by larger areas of hair loss at the temples and vertex, with a narrower and sparser band of hair between them. The hair loss is more extensive than in stage 4.",
            'duration': '6 Months',
            'possibility': '35%',
            'img_side': stg5_side_prev,
            'img_top': stg5_top_prev,
        },
        "stage 6": {
            'description': "Stage 6 male pattern hair loss is marked by the balding areas at the temples and vertex join, leaving little to no hair across the top of the head. The remaining hair forms a horseshoe shape around the sides and back of the head.",
            'duration': '6 Months',
            'possibility': '20%',
            'img_side': stg6_side_prev,
            'img_top': stg6_top_prev,
        },
        "stage 7": {
            'description': "Stage 7 male pattern hair loss is marked by the most severe stage, with only a thin band of hair remaining around the sides of the head. This hair is usually not dense and may be fine.",
            'duration': '6 Months',
            'possibility': '10%',
            'img_side': stg7_side_prev,
            'img_top': stg7_top_prev,
        }
    };
    let stage = JSON.parse(localStorage.getItem('stage'))

    function capitalizeFirstLetter(val) {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }

    function checkReport() {
        navigate('/resultnew')
    }

    return (
        <div className='photo-container main-section-container assessmentReportSection'>
            <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
                <Grid item xs={1} className=''>
                    <div className='d-flex justify-content-start align-items-center'>

                        <span className='backButtonDiv' onClick={() => navigate('/imgupload')}>
                            <ArrowBackOutlinedIcon className='arrowBackBtn'></ArrowBackOutlinedIcon>
                        </span>
                    </div>
                </Grid>
                <Grid item xs={11} className='d-flex justify-content-center align-items-center'>
                    <Typography variant="h6" className="title ml-0px">Personalised Hair Analysis</Typography>
                </Grid>

            </Grid>
            <Card className="mt-20px assessmentCard">
                <CardContent>
                    <div className='mt-20px'>

                        <Grid container spacing={2} className='mt-20px mb-4'>
                            <Grid item xs={4} className='diagnosedImagegrid'>
                                <div>
                                    {/* <img src={imgurl.reportImg} className='reportImg'></img> */}
                                    {/* <img src={imgurl.reportImg} className='reportImg'></img> */}
                                    <img src={norwoodHamiltonStages[stage]['img_side']} className='reportImg' />

                                </div>
                                <div>
                                    <img src={norwoodHamiltonStages[stage]['img_top']} className='reportImg' />
                                </div>

                            </Grid>
                            <Grid item xs={8} className='d-flex justify-content-center align-items-start flex-direction-column diagnosedInfogrid' style={{ paddingLeft: "35px" }}>
                                <Typography className='text-left assessment-title'>
                                    Hi, based on the analysis, you have been diagnosed with,
                                </Typography>
                                <Typography variant="h6" className="commonMainTitle">Male Pattern Hair Loss</Typography>
                                <Button variant='outlined' className='stageButton'> {capitalizeFirstLetter(stage)}</Button>
                            </Grid>
                        </Grid>
                        <div className='border-bottom-dashed'></div>
                        <div className='text-left pt-10px'>
                            <Typography variant="body2" className='subtitle '>
                                {norwoodHamiltonStages[stage]['description']}
                            </Typography>
                            <Typography variant="body2" className='subtitle '>
                                {/* Stage 3 of the Norwood Hamilton Scale is often the first indicator of male pattern baldness. */}
                            </Typography>
                        </div>
                    </div>

                </CardContent>
            </Card>
            <div className='text-left mt-20px'>
                {/* <p className='textReport'>To receive a more detailed report, please register.</p> */}
                <FormControlLabel
                    className='formConsent'
                    control={<Checkbox checked={consentchk} onChange={toggleChckBox} />}
                    label={
                        <>

                            Please feel free to connect with us on WhatsApp
                            <WhatsAppIcon className='iconWhatsapp'></WhatsAppIcon>
                            for more detailed information regarding the analysis.

                        </>
                    }
                />
            </div>
            <div className='linkbtnsec'>

                <Button variant="contained" onClick={() => checkReport()} className='commonButton'>
                    Get Detailed Analysis

                </Button>
                <br></br>
                {/* <Button variant="contained" onClick={() => navigate('/RegisterShortReport')} className='commonButton'>
                    Explore Treatment

                </Button> */}
            </div>
        </div>
    )
}

export default AssessmentReport